// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1mZge","validationTips":"StatementDescriptor_validationTips__3M7mS"};